import { DataModel } from "@essenza/core";

export function SystemModel() {
    DataModel.call(this, "system");
  }